<template>
  <div class="pagecart-retail">
    <XR-edit-head titleText="购物车" :rightButtonText="'编辑'" :rightButtonShow="editButtonShow" ref="head" @editEvent="editEvent" @completeEvent="completeEvent" ></XR-edit-head> 

    <div class="cart-list" v-if="!loaded && productList.length>0">
      <div class="cart-item" v-for="cartItem in productList" :key="cartItem.ShopId">
        <div class="shopRow">          
          <!-- <div class="all-chk"><mu-checkbox class="cart-all-chk" :nativeValue="cartItem.ShopId" @change="shopClick(cartItem.ShopId)" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/></div> -->
          <div class="shopName">
            <span>{{cartItem.ShopName}}</span>
            <i class="fa fa-angle-right"></i>
          </div>      
        </div>
        <div class="pro-list">
          <div class="pro-item" v-for="productItem in cartItem.Products" :key="productItem.SkuId">
            <div class="chk">
              <mu-checkbox class="cart-chk" :nativeValue="productItem.SkuId.toString()" v-model="checkList"  uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/>
            </div>
            <div class="pro-img">
              <router-link :to="'/wholesale/productDetail?skuId='+productItem.SkuId"><img :src="productItem.DefaultImg?productItem.DefaultImg:IMGServer_URL+'/images/index-item-default.png'" /></router-link>
            </div>
            <div class="pro-info" :style="{width:cartItemProductInfoWidth+'px'}">
              <router-link :to="'/wholesale/productDetail?skuId='+productItem.SkuId"><p class="pro-name">{{productItem.Name}}</p></router-link>
              <p class="pro-attr">
                <template v-for="attrItem in productItem.Attrs">
                  {{attrItem.AttrName +":" + attrItem.AttrValue}} 
                </template>
              </p>
              <div class="pro-num">
                <p class="pro-price">
                  <template v-if="productItem.State==0">
                    <i class="fa fa-rmb"></i>{{productItem.SalePrice.toFixed(2)}}
                  </template>
                  <template v-else>
                    商品已下架
                  </template>
                </p>
                <div class="jiajian-ctrl">
                  <span class="btn jian" @click="minusCartItem(productItem.SkuId, productItem.Stock)">-</span>
                  <span class="count">{{getCartItemCount(productItem.SkuId)}}</span>
                  <span class="btn jia" @click="plusCartItem(productItem.SkuId, productItem.Stock)">+</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-bar">
      <mu-row >
        <mu-col width="65" tablet="65" desktop="65">
          <div class="cart-all-chk">            
            <mu-checkbox label="全选" @change="checkAll()" v-model="checkAllState" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/>
          </div>
          <template v-if="mode == 'normal'">
            <p class="cart-total">
              <span class="text">共</span>
              <span class="money">{{totalCount}}</span>件
              <span class="text"><i class="fa fa-rmb"></i></span>
              <span class="money">{{totalPrice.toFixed(2)}}元</span>
            </p>
          </template>
          <mu-col width="35" tablet="35" desktop="35"  v-if="mode == 'normal'">
            <mu-flat-button @click="goToBuy" label="去结算" class="gobuy" backgroundColor="red" color="white" fullWidth />
          </mu-col>
          <template v-else>
            <mu-flat-button class="operatorBtn" backgroundColor="red" color="white" @click="deleteCart()" label="删除" fullWidth></mu-flat-button>
            <mu-flat-button class="operatorBtn" backgroundColor="#FF2F66" color="white" @click="clearCart()" label="清空" fullWidth></mu-flat-button>
          </template>
        </mu-col>
        
      </mu-row>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
    <mu-dialog :open="dialog" title="确定要删除吗" @close="close">      
      <mu-flat-button slot="actions" @click="close" backgroundColor="red" color="white" primary label="取消"/>
      <mu-flat-button slot="actions" primary @click="removeCartItem()" label="确定"/>
    </mu-dialog>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
import cart from '../../util/purchaseCart'
export default {
  data () {
    return {
      loaded:true,
      dialog: false,
      fullHeight: (parseInt(document.documentElement.clientHeight)+96),
      cartItemProductInfoWidth: (parseInt(document.documentElement.clientWidth)-130),
      cartList: [],
      productList:[],
      deleteSkuId : 0,
      checkList:[],
      skuList:[],
      skuPriceList:[],
      checkAllState:true,
      totalPrice:0,
      totalCount:0,
      
      mode: this.$route.query.mode?this.$route.query.mode:'normal', //如果mode=normal，则代表正常，如果mode=select，则代表选择模式，选中即跳转回去
      editButtonShow: this.$route.query.mode == 'select' ?false:true,
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load()
    this.getCartList()
  },
  methods: {
    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    checkAll(){
      if(!this.checkAllState){        
        this.checkList = this.skuList
      }else{
        this.checkList = []
      }
    },
    getCartList: function(){
      this.cartList = cart.getList()
      if(this.cartList.length ==0){
        this.editButtonShow = false
        this.productList =[]
        this.$refs.XRtoast.hide()
        this.$refs.XRPageTip.ShowEmpty('购物车为空')
        return
      }
      var data = {skuIds:[]}
      for(var i =0; i< this.cartList.length ; i++){
        data.skuIds.push(this.cartList[i].skuId)
      }
      this.skuList = data.skuIds

      var ths = this;   
      ths.$post(
        "/Shop/PurchaseServer/GetCartProductList",
        JSON.stringify(data)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
          ths.$refs.XRPageTip.ShowEmpty('购物车为空')
        }else{      
          ths.productList = res.Data
          ths.skuPriceList = []
          for(var i = 0; i<ths.productList.length;i++){
            for(var j = 0; j< ths.productList[i].Products.length;j++){
              ths.skuPriceList.push({skuId: ths.productList[i].Products[j].SkuId, price: ths.productList[i].Products[j].SalePrice})
            }
          }
          ths.checkList = ths.skuList
          ths.$refs.XRtoast.hide()
          ths.$refs.XRPageTip.initTip()
          ths.loaded = false
        }
      });
    },
    getCartItemCount: function(skuId){
      for(var i = 0; i < this.cartList.length; i++){
        if(this.cartList[i].skuId == skuId){
          var cnt = this.cartList[i].count
          return cnt
        }
      }
      return 0
    },
    plusCartItem: function(skuId){
      cart.addItem(skuId,1)
      this.cartList = cart.getList()
    },
    minusCartItem: function(skuId){
      if(this.getCartItemCount(skuId)-1 == 0){
        this.deleteSkuId = skuId
        this.open()
        return
      }
      cart.minusItem(skuId)
      this.cartList = cart.getList()
    },
    removeCartItem: function(){
      this.dialog = false
      if(this.deleteSkuId == 0){
        return
      }
      
      cart.removeItem(this.deleteSkuId)
      this.getCartList()
    },
    goToBuy(){
      if(this.checkList.length ==0){
        this.$refs.XRtoast.failed("未勾选要购买的商品", true)
        return
      }
      this.$router.push('/wholesale/orderSubmit')
    },
    getPriceTotal(){
      var check = this.checkList
      var list = cart.getList()
      for(var i = 0; i< list.length;i++){
        cart.checkItem(list[i].skuId, false)
        for(var j = 0; j< check.length;j++){
          if(list[i].skuId == check[j]){
            cart.checkItem(list[i].skuId, true)
          }
        }
      }

      var price = 0
      var cnt = 0
      list = cart.getList()
      for(var i =0;i<list.length;i++){
        if(list[i].select){
          for(var j = 0; j< this.skuPriceList.length; j++){
            if(list[i].skuId == this.skuPriceList[j].skuId){
              cnt += list[i].count
              price += list[i].count * this.skuPriceList[j].price
            }
          }
        }
      }
      this.totalCount = cnt
      this.totalPrice = price
    },    
    editEvent: function(){
      this.mode='edit';
    }, 
    completeEvent: function(){
      this.mode='normal';
    },
    deleteCart(){
      if(this.checkList.length==0){
        this.$refs.XRtoast.failed("未勾选要删除的商品", true)
        return
      }
      cart.clearSelectList()
      this.getCartList()
    },
    clearCart(){
      cart.clearList()
      this.getCartList()
    }
  },
  watch:{
    checkList(){
      if(this.checkList.length != this.skuList.length){
        this.checkAllState = false
      }else{
        this.checkAllState = true
      }
      this.getPriceTotal()
    },
    cartList(){
      this.getPriceTotal()
    }
  }
}
</script>
<style>
.pagecart-retail{
  background: #F0F2F5;
}

.pagecart-retail .cart-list{
  overflow: hidden;
  padding-bottom: 56px;
}
.pagecart-retail .cart-item{
  margin-top: 10px;
  background: white;
}


.pagecart-retail .shopRow{
  background: #F8F8F8;
  overflow: hidden;
  color:#666;
  width: 100%;
  line-height: 40px;
  height: 40px;
  border-top:#ddd solid 1px;
}
.pagecart-retail .shopRow .all-chk{
  float: left;
  width: 40px;
  margin-top: 6px;
  text-align: center;
}
.pagecart-retail .shopRow .shopName{
  padding-left: 10px;
}

.pagecart-retail .pro-list{
  overflow: hidden;
}
.pagecart-retail .pro-list .pro-item{
  padding: 16px 0;
  overflow: hidden;
}
.pagecart-retail .pro-list .pro-item .chk{
  width: 40px;
  text-align: center;
  line-height: 80px;
  float: left;
}

.pagecart-retail .pro-list .pro-item .pro-img{
  width: 80px;
  float: left;
}
.pagecart-retail .pro-list .pro-item .pro-img img{
  width: 100%;
  display: block;
  border-radius: 4px;
}
.pagecart-retail .pro-list .pro-item .pro-info{
  float: right;
  padding-right: 10px;
}
.pagecart-retail .pro-list .pro-item .pro-info .pro-name{
  font-size: 12px;
  line-height: 16px;
  height: 32px;
  padding-bottom: 4px;
  overflow: hidden;
  color:#999;
}
.pagecart-retail .pro-list .pro-item .pro-info .pro-attr{
  font-size: 12px;
  line-height: 16px;
  height: 30px;
  color:#999;
}
.pagecart-retail .pro-list .pro-item .pro-info .pro-num{
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  color:#999;
}
.pagecart-retail .pro-list .pro-item .pro-info .pro-num .pro-price{
  font-size: 16px;
  line-height: 16px;
  color:#999;
  float: left;
  color:red;
}
.pagecart-retail .pro-list .pro-item .pro-info .pro-num .pro-price .fa{
  font-size: 12px;
}
.pagecart-retail .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl{
  float: right;
}
.pagecart-retail .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl span{
  float: left;
  width: 20px;
  text-align: center;
}
.pagecart-retail .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl .count{
  border: 1px solid #eee;
  width: 30px;
  border-left: 0;
  border-right: 0;
}
.pagecart-retail .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl .btn{
  border: 1px solid #eee;
}
.pagecart-retail .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl .jian{
  border-radius:2px 0 0 2px;
}
.pagecart-retail .pro-list .pro-item .pro-info .pro-num .jiajian-ctrl .jia{
  border-radius:0 2px 2px 0;
}




.pagecart-retail .bottom-bar{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  height: 56px;
  border-top:1px solid #eee;
}
.pagecart-retail .bottom-bar .cart-all-chk{
  float: left;
  width: 25%;
  text-align: left;
  height: 24px;
  margin: 16px 0;
}
.pagecart-retail .bottom-bar .cart-total{
  float: left;
  height: 56px;
  width: 40%;
  line-height: 56px;
  font-size: 12px;
}
.pagecart-retail .bottom-bar .cart-total .text .fa{
  color:red;
}
.pagecart-retail .bottom-bar .cart-total .money{
  color:Red;
}
.pagecart-retail .gobuy{
  width: 100%;
  line-height: 56px;
  height: 56px;
  text-align: center;
}
.pagecart-retail .no-gutter .desktop-65 .operatorBtn:nth-child(2){
  margin-left:5%; 
}
.pagecart-retail .bottom-bar .operatorBtn{
  float: left;
  width: 35%;
  height: 56px;
  line-height: 56px;
  font-size: 12px;
}
.pagecart-retail .mu-flat-button{
  border-radius: 0;
}
.pagecart-retail .no-gutter .desktop-65{display: flex;width: 100%;}
.pagecart-retail .no-gutter .desktop-65 .mu-checkbox{margin-left: 5%}
</style>



// WEBPACK FOOTER //
// src/pages/wholesale/cart.vue